import Vue from 'vue/dist/vue.js';

export default {
    name: 'product-card-auction-countdown',
    _el: null,

    init() {
        const elements = document.querySelectorAll('.auction-countdown');

        for(let i=0; i <elements.length; i++) {
            this.run(elements[i].id);
        }
    },

    run (elementId)
    {
        if (typeof elementId !== 'string' || elementId.length === 0) {
            return false;
        }

        new Vue({
            el: '#'+elementId,

            delimiters: ['@{', '}'],

            data:
            {},

            created()
            {},
        });
    }
}